export const MODIFY_MODAL_QUERY_QUICKSTART_TYPE = 'MODIFY_MODAL_QUERY_QUICKSTART_TYPE';

export function modifyModalQueryQuickstartType(modalQueryQuickstartType){
    return{
        type: MODIFY_MODAL_QUERY_QUICKSTART_TYPE,
        mainState: {
            modalQueryQuickstartType: modalQueryQuickstartType
        }
    }
}